import { render, staticRenderFns } from "./el-link.vue?vue&type=template&id=b3ef39c2"
import script from "./el-link.vue?vue&type=script&lang=js"
export * from "./el-link.vue?vue&type=script&lang=js"
import style0 from "./el-link.vue?vue&type=style&index=0&id=b3ef39c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports